import React from 'react'
import type { FC } from 'react'
import { useTheme } from '@mui/material'
import { Ellipse } from '../Icon'
import { PinBox } from './styles'
import type { PinCodeFieldProps } from './types'

const PinCodeField: FC<PinCodeFieldProps> = ({ error, selected, hasValue }) => {
  const { palette } = useTheme()

  return (
    <PinBox data-testid="pin-code-field" error={error} selected={selected}>
      {hasValue && <Ellipse color={error ? palette.error.dark : palette.text.primary} />}
    </PinBox>
  )
}

export default PinCodeField
